import React, { createContext, useContext } from 'react';
import { Promotion } from '@shared/types';

const PromotionContext = createContext<Promotion | null>(null);

export const PromotionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Promotion endpoint removed. Always return null.
  return (
    <PromotionContext.Provider value={null}>
      {children}
    </PromotionContext.Provider>
  );
};

export const usePromotion = () => useContext(PromotionContext);
